module.exports = __webpack_public_path__ + "img/question-null.6e9e2c77.svg";